import { render, staticRenderFns } from "./SeeDetails.vue?vue&type=template&id=1fcbeaf6&scoped=true&"
import script from "./SeeDetails.vue?vue&type=script&lang=ts&"
export * from "./SeeDetails.vue?vue&type=script&lang=ts&"
import style0 from "./SeeDetails.vue?vue&type=style&index=0&id=1fcbeaf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcbeaf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VCardTitle,VDialog,VImg})
